<template>
  <a-menu
      theme="dark"
      mode="inline"
      :selectedKeys="key"
      :open-keys="openkey"
      @openChange="handleOpenChange"
  >
    <template v-for="menu in menuData">
      <a-sub-menu :key="menu.key" v-if="menu.children.length > 0 && checkSubMenu(menu.children)">
        <span slot="title">
          <a-icon :type="menu.icon" style="font-size:16px;"/>
          <span>{{ menu.title }}</span>
        </span>
        <template v-for="child in menu.children">
          <a-menu-item :key="child.key" v-if="child.children.length == 0 && checkMenuItem(child)">
            <router-link :to="child.url" class="child-link">
              {{ child.title }}
              <template
                  v-if="child.title == '已关闭订单' && closed && closed.count > 0"
              >
                <a-badge
                    :numberStyle="{ backgroundColor: '#fff', color: '#555' }"
                    :count="closed.count"
                />
              </template>
              <template
                  v-if="
                  child.title == '进行中订单' && process && process.count > 0
                "
              >
                <a-badge
                    :numberStyle="{ backgroundColor: '#fff', color: '#555' }"
                    :count="process.count"
                />
              </template>
              <template v-if="child.title == '已完成订单' && done && done.count > 0">
                <a-badge
                    :numberStyle="{ backgroundColor: '#fff', color: '#555' }"
                    :count="done.count"
                />
              </template>
              <template v-if="child.title == '猎头求助订单' && helpnum > 0">
                <a-badge
                    :numberStyle="{ backgroundColor: '#fff', color: '#555' }"
                    :count="helpnum"
                />
              </template>
            </router-link>
          </a-menu-item>
        </template>
      </a-sub-menu>

      <a-menu-item
          :key="menu.key"
          v-if="menu.children.length == 0 && checkMenuItem(menu)"
          @click="pushUrl(menu)"
      >
        <a-icon :type="menu.icon" style="font-size:16px;"/>
        <span>{{ menu.title }}</span>
        <a-badge
            v-if="menu.key === 'im'"
            :numberStyle="{ backgroundColor: '#fff', color: '#555',marginLeft:'40px' }"
            :count="totalUnreadCount"
        />
      </a-menu-item>
    </template>
  </a-menu>
</template>

<script>
import menuData from "./menu-item";
import {mapGetters} from "vuex";
import Api from "@/api";

export default {
  name: "SideMenu",
  data() {
    return {
      menuData,
      key: [this.$route.meta.key],
      openkey: [],
      helpnum: 0
    };
  },
  computed: {
    ...mapGetters(["isGranted", "isAnyGranted"]),
    ...mapGetters("im", ["totalUnreadCount"]),
    process() {
      return this.$store.getters.orderStatus("process");
    },
    done() {
      return this.$store.getters.orderStatus("done");
    },
    closed() {
      return this.$store.getters.orderStatus("closed");
    }
  },
  watch: {
    $route(route) {
      this.key = [route.meta.key];
    }
  },
  created() {
    let menu = this.menuData.find(item => {
      if (item.children.length > 0) {
        return item.children.some(child => {
          return child.key == this.key[0];
        });
      } else {
        return false;
      }
    });
    if (menu) {
      this.openkey = [menu.key];
    }
    Api.hunter.ask_help({
      statuses: 1
    }).then(res => {
      let n = Number(res.type_counts.accept) + Number(res.type_counts.accept_fail) + Number(res.type_counts.complete) + Number(res.type_counts.create);

      this.helpnum = n;
    });
  },
  methods: {
    checkSubMenu(menus) {
      let permission = menus.map(item => item.permission);
      return this.isAnyGranted(permission);
    },
    checkMenuItem(menu) {
      return this.isGranted(menu.permission);
    },
    handleOpenChange(keys) {
      this.openkey = keys;
    },
    pushUrl(menu) {
      if (this.$route.fullPath != menu.url) {
        this.$router.replace(menu.url);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.child-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
